angular.module('mtic').service('flashPermission', function ($log) {

    // Public Methods
    var flashPermission = {

        getPermission : function() {
            return;
          function requestFlashPermission() {
            //window.onbeforeunload = null;
            // console.log('asking');
            var iframe = document.createElement('iframe');
            iframe.src = 'https://get.adobe.com/flashplayer';
            iframe.sandbox = '';
            document.body.appendChild(iframe);
            document.body.removeChild(iframe);
            window.removeEventListener('click', requestFlashPermission);
          }

          var isNewEdge = (navigator.userAgent.match(/Edge\/(\d+)/) || [])[1] > 14;
          var isNewSafari = (navigator.userAgent.match(/OS X (\d+)/) || [])[1] > 9;
          var isNewChrome = (navigator.userAgent.match(/Chrom(e|ium)\/(\d+)/) || [])[2] > 56 && !/Mobile/i.test(navigator.userAgent);
          var canRequestPermission = isNewEdge || isNewSafari || isNewChrome;

          if (canRequestPermission) {
              requestFlashPermission();
              window.addEventListener('click', requestFlashPermission);
          }
        }
    }


    return flashPermission;
})
